import { Application } from 'stimulus';
import { definitionsFromContext } from 'stimulus/webpack-helpers';

import './bootstrap';

import general from './containers/general';
import cart from './containers/cart';
import payment from './containers/payment';

import sentry from './sentry';

sentry();

const application = Application.start();
const context = require.context('./controllers', true, /\.js$/);
application.load(definitionsFromContext(context));

general();

if (document.querySelector('.js-cart')) {
  cart();
}

if (document.querySelector('.js-payment')) {
  payment();
}

if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/service-worker.js')
      .then(() => {
        // Registration was successful
      })
      .catch((err) => {
        console.log('ServiceWorker registration failed: ', err); // eslint-disable-line
      });
  });
}
